var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUprightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2485_814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1436 1.50226L14.1778 11.5474M15.1436 1.50226L5.08068 2.26068M15.1436 1.50226L8 8.50001L2 14",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2485_814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUprightArrow);
export default __webpack_public_path__ + "static/media/upright-arrow.253ed258555c51bb6fc7a514f0d03039.svg";
export { ForwardRef as ReactComponent };